import { Transition } from '@uirouter/core';
import { ISCEService, IScope, ITimeoutService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import UtilService from '../../common/services/util.service';
import { CardDeleteAction } from '../../buy/card-delete-dialog/card-delete-dialog.action';
import { PaymentMethod } from '../../buy/services/payment-method.model';
import { PaycellService } from '../../buy/services/paycell.service';
import GoogleAnalyticsService from '../../common/services/analytics/google-analytics.service';
import { DeleteCreditCardEvent } from '../../common/services/analytics/events/dimensions';


import { OpenSameAddressAlertAction } from './family-plan-member-same-address-alert-dialog.action';

import { IPromise, IWindowService } from 'angular';

/* @ngInject */
export default class FamilyPlanUserRegistrationDialogController implements ActionHandler {
  private dialogElement;
  public memberNewAddress: any;
  public memberEmail:any;
  public memberBirthday:string;
  public memberDay:any;
  public memberMonth:any;
  public memberYear:any;
  public membersMasterToken:any;
  // protected card: PaymentMethod;
  // protected onDeleteSuccess: (paymentMethodID) => any;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $state,
    private $scope: IScope,
    private $timeout: ITimeoutService,
    private paycellService: PaycellService,
    private googleAnalytics: GoogleAnalyticsService,
    private $window: IWindowService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#family-plan-member-same-address-alert-dialog').remodal();
    
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenSameAddressAlertAction) {
      // this.card = action.card;
      // this.onDeleteSuccess = action.onDeleteSuccess;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public isActive(destination: string) {
    return destination === this.$window.location.pathname;
  }

  private close() {
    this.dialogElement.close();
  }

  public onClose() {
    this.close();
}
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-member-same-address-alert-dialog/family-plan-member-same-address-alert-dialog.controller.ts